const config = {
  
  bucketName: process.env.REACT_APP_BUCKET_NAME,
  region: process.env.REACT_APP_AWS_REGION,
  dirName: process.env.REACT_APP_AWS_DIR_NAME,          
  accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY_ID,
  secretAccessKey: process.env.REACT_APP_AWS_SECRET_ACCESS_KEY,
};
export default config;